"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("./extends-fa579b0f.js"),
  t = require("./defineProperty-b53f90b9.js"),
  n = require("./slicedToArray-a539bf82.js"),
  a = require("react"),
  r = require("prop-types"),
  i = require("./typography-fb2881fe.js"),
  o = require("./foundations/Icon/icons/utility/DrawerCaretFlipped.js"),
  c = require("./foundations/Icon/icons/utility/DrawerCaret.js"),
  l = require("./taggedTemplateLiteral-97b463ad.js"),
  d = require("polished/lib/helpers/rem"),
  s = require("styled-components"),
  u = require("./styles-df7980c2.js");
function p(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var f,
  g,
  m,
  y,
  h,
  b,
  O,
  T,
  v,
  P = p(a),
  j = p(r),
  w = p(d),
  A = p(s);
function x(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function S(e) {
  for (var n = 1; n < arguments.length; n++) {
    var a = null != arguments[n] ? arguments[n] : {};
    n % 2 ? x(Object(a), !0).forEach(function (n) {
      t._defineProperty(e, n, a[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : x(Object(a)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
    });
  }
  return e;
}
var k = A["default"].button(f || (f = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      n = e.variant,
      a = e.isOpen,
      r = e.isFAQ,
      i = "".concat(w["default"](22), " 0");
    return "secondary" === n && (i = w["default"](22), r && (i = w["default"](24), "true" === a && (i = "".concat(w["default"](24), " ").concat(w["default"](24), " ").concat(w["default"](16))))), s.css(g || (g = l._taggedTemplateLiteral(["\n      display: flex;\n      position: relative;\n      width: 100%;\n      padding: ", ";\n      background: inherit;\n      border: 0;\n      justify-content: flex-start;\n      align-items: center;\n      color: ", ";\n\n      &.is-accordion-item-expanded {\n        ", "\n      }\n\n      &:hover {\n        .accordion-item-title {\n          color: ", ";\n        }\n        .accordion-toggle-icon {\n          .icon-fill {\n            fill: ", ";\n          }\n        }\n      }\n    "])), i, t.colors.neutral.grayDark20, "primary" === n && "\n          color: ".concat(t.colors.action.lightTheme.ctaBgDefault, ";\n          .accordion-toggle-icon {\n            color: ").concat(t.colors.action.lightTheme.ctaBgDefault, ";\n          }\n        "), t.colors.action.lightTheme.ctaBgHover, t.colors.action.lightTheme.ctaBgHover);
  }),
  I = A["default"].dd(m || (m = l._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme,
      n = e.variant,
      a = e.isFAQ,
      r = t.mediumUp(),
      i = "secondary" === n && a;
    return s.css(y || (y = l._taggedTemplateLiteral(["\n      margin: 0;\n      padding-bottom: ", ";\n      /** Secondary: 70 = 24 (button padding) + 30 (icon width) + 16 left-margin */\n      /** right padding only active for FAQ (for now) */\n      ", "\n\n      ", "\n    "])), i ? w["default"](24) : w["default"](22), "secondary" === n && "\n        padding-left: ".concat(w["default"](22), ";\n        padding-right: ").concat(w["default"](22), ";\n      "), i && "\n        padding-left: ".concat(w["default"](24), ";\n        padding-right: ").concat(r ? w["default"](70) : w["default"](24), ";\n      "));
  }),
  q = A["default"].div(h || (h = l._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.backgroundVariant,
      n = e.branding,
      a = e.isFAQ,
      r = e.theme,
      i = e.themeType,
      o = e.variant,
      c = "".concat(w["default"](1), " solid ").concat(r.colors.neutral.grayLight10);
    return s.css(b || (b = l._taggedTemplateLiteral(["\n    border-bottom: ", ";\n    ", ";\n\n    ", "\n  "])), c, a && "\n      :first-of-type {\n        ".concat(c, "\n      }\n    "), "secondary" === o && "\n      background-color: ".concat(u.getSectionBackgroundColor(t, n, r, i), ";\n      margin-bottom: ").concat(w["default"](16), ";\n      border: 0;\n    "));
  }),
  _ = A["default"].dt(O || (O = l._taggedTemplateLiteral(["\n  width: 100%;\n"]))),
  D = A["default"](i.TypographyComponent)(T || (T = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.leftPadding,
      n = e.variant;
    return s.css(v || (v = l._taggedTemplateLiteral(["\n    flex: 1 1 auto;\n    padding-top: ", ";\n    ", "\n    ", "\n  "])), w["default"](6), "primary" === n && "\n      font-size: ".concat(w["default"](17), ";\n    "), t && "\n      padding-left: ".concat(w["default"](16), ";\n    "));
  });
function E(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function F(e) {
  for (var n = 1; n < arguments.length; n++) {
    var a = null != arguments[n] ? arguments[n] : {};
    n % 2 ? E(Object(a), !0).forEach(function (n) {
      t._defineProperty(e, n, a[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : E(Object(a)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
    });
  }
  return e;
}
var Q = function Q(t) {
  var r,
    o,
    c = t.addFAQPageSchemaItemType,
    l = t.backgroundVariant,
    d = t.branding,
    u = t.className,
    p = t.firstItemOpen,
    f = t.id,
    g = t.isFAQ,
    m = t.items,
    y = t.themeType,
    h = t.toggleCloseIcon,
    b = t.toggleOpenIcon,
    O = t.variant,
    T = (r = a.useContext(s.ThemeContext), o = r.mediumUp(), {
      TitleIconStyled: S({
        flexShrink: 0,
        maxWidth: w["default"](28),
        height: w["default"](33)
      }, o && {
        height: "100%"
      }),
      IconToggleStyled: {
        flexShrink: 0,
        color: r.colors.action.lightTheme.ctaBgDefault,
        marginLeft: w["default"](16)
      }
    }),
    v = a.useState(m.map(function (e, t) {
      return F(F({}, e), {}, {
        isOpen: !(!p || 0 !== t)
      });
    })),
    j = n._slicedToArray(v, 2),
    A = j[0],
    x = j[1],
    E = b,
    Q = h,
    C = "primary" === O ? "h4" : "h3",
    L = "primary" === O ? 15 : 30,
    B = {
      style: T.IconToggleStyled,
      height: L,
      width: L,
      className: "accordion-toggle-icon"
    };
  return P["default"].createElement("dl", e._extends({
    className: u,
    id: f,
    itemScope: g && c
  }, g && c && {
    itemType: "https://schema.org/FAQPage"
  }), A.map(function (t, n) {
    return P["default"].createElement(q, e._extends({
      backgroundVariant: l,
      branding: d,
      id: "container-".concat(t.id),
      isFAQ: g,
      itemScope: g,
      key: "".concat(t.title, "-").concat(n + 1),
      themeType: y,
      variant: O
    }, g && {
      itemProp: "mainEntity",
      itemType: "https://schema.org/Question"
    }), P["default"].createElement(_, {
      id: "dt-container-".concat(t.id)
    }, P["default"].createElement(k, {
      "aria-expanded": t.isOpen,
      className: t.isOpen && "is-accordion-item-expanded",
      id: "dt-button-".concat(t.id),
      isFAQ: g,
      isOpen: t.isOpen,
      onClick: function onClick() {
        x(A.map(function (e, t) {
          return F(F({}, e), {}, {
            isOpen: n === t ? !e.isOpen : e.isOpen
          });
        }));
      },
      variant: O
    }, t.icon && P["default"].createElement(t.icon, {
      style: T.TitleIconStyled
    }), P["default"].createElement(D, e._extends({
      align: "left",
      className: "accordion-item-title",
      component: "h3",
      disableBottomPadding: !0,
      id: "dt-title-".concat(t.id),
      leftPadding: !!t.icon,
      variant: C
    }, g && {
      itemProp: "name"
    }), t.title), t.isOpen ? P["default"].createElement(Q, B) : P["default"].createElement(E, B))), P["default"].createElement(I, e._extends({
      id: "dd-container-".concat(t.id),
      isFAQ: g,
      itemScope: g,
      style: {
        display: t.isOpen ? "block" : "none"
      },
      variant: O
    }, g && {
      itemProp: "acceptedAnswer",
      itemType: "https://schema.org/Answer"
    }), P["default"].createElement(i.TypographyComponent, e._extends({
      as: t.contentAs || "p",
      disableBottomPadding: !0
    }, g && {
      itemProp: "text"
    }), t.content)));
  }));
};
Q.propTypes = {
  backgroundVariant: j["default"].oneOf(["darkDefault", "lightA", "lightB", "lightC"]),
  branding: j["default"].oneOf(["nm", "pcg"]),
  addFAQPageSchemaItemType: j["default"].bool,
  className: j["default"].string,
  firstItemOpen: j["default"].bool,
  id: j["default"].string.isRequired,
  isFAQ: j["default"].bool,
  items: j["default"].arrayOf(j["default"].shape({
    id: j["default"].any.isRequired,
    icon: j["default"].any,
    title: j["default"].any.isRequired,
    content: j["default"].any.isRequired
  })).isRequired,
  themeType: j["default"].oneOf(["lightTheme", "darkTheme", "nmx-pcg"]),
  toggleCloseIcon: j["default"].any,
  toggleOpenIcon: j["default"].any,
  variant: j["default"].oneOf(["primary", "secondary"])
}, Q.defaultProps = {
  addFAQPageSchemaItemType: !0,
  backgroundVariant: "lightC",
  branding: "nm",
  firstItemOpen: !1,
  isFAQ: !1,
  themeType: "lightTheme",
  titleTypographyProps: {},
  toggleCloseIcon: o,
  toggleOpenIcon: c,
  variant: "primary"
}, exports.AccordionComponent = Q;